/** CDN origin for woodwork photos and manifest (see media/README.md). */

const productionMediaBase = 'https://media.tristanjhall.com'

export const woodworkIndexPath = 'woodwork/manifest.json'

export function woodworkProjectManifestPath(projectId: string): string {
  return `woodwork/${projectId}/manifest.json`
}

function resolveMediaBaseUrl(): string {
  const configured = process.env.REACT_APP_MEDIA_BASE_URL
  if (configured !== undefined && configured !== '') {
    return configured.replace(/\/$/, '')
  }
  if (process.env.NODE_ENV === 'development') {
    return ''
  }
  return productionMediaBase
}

/** Empty in local dev → same-origin `/woodwork/...` from `public/woodwork/` (see make media-dev-sync). */
export const mediaBaseUrl = resolveMediaBaseUrl()

export const useLocalMedia = mediaBaseUrl === ''

export function mediaUrl(path: string): string {
  const normalized = path.replace(/^\//, '')
  if (!mediaBaseUrl) {
    return `/${normalized}`
  }
  return `${mediaBaseUrl}/${normalized}`
}

export const woodworkIndexUrl = mediaUrl(woodworkIndexPath)

export function woodworkProjectManifestUrl(projectId: string): string {
  return mediaUrl(woodworkProjectManifestPath(projectId))
}
